// lotListApiSlice.js
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../../apiSlice";

/* ---------- Adapter ---------- */
const lotAdapter = createEntityAdapter({
  selectId: (lot) => lot.id,
});

const initialState = lotAdapter.getInitialState();

/* ---------- API ---------- */
export const lotSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInventorySpareLot: builder.query({
      query: ({ seller_id }) =>
        `inventory/spares/lots?seller_id=${seller_id}`,

      transformResponse: (response) =>
        lotAdapter.setAll(
          { ...initialState }, // ✅ SAFE
          response?.data ?? []
        ),
    }),
  }),
});

export const { useGetInventorySpareLotQuery } = lotSlice;

/* ---------- Selector factory ---------- */
export const makeSelectLotSelectors = (seller_id) => {
  const selectLotQueryResult =
    lotSlice.endpoints.getInventorySpareLot.select({ seller_id });

  const selectLotData = createSelector(
    [selectLotQueryResult],
    (result) => result?.data ?? initialState
  );

  return lotAdapter.getSelectors((state) => selectLotData(state));
};
